import type { Phrase } from '../types';
import type { staffEn } from './staff.en';

export const staffMl: Partial<Record<keyof typeof staffEn, Phrase>> = {
  statusFollowUp: 'ഫോളോ-അപ്പ്',
  statusInterested: 'താൽപ്പര്യമുണ്ട്',
  statusBooked: 'ബുക്ക് ചെയ്തു',

  enqAnyVenue: 'എല്ലാ വേദികളും',
  enqReceivedFrom: 'ലഭിച്ചത് (മുതൽ)',
  enqReceivedTo: 'ലഭിച്ചത് (വരെ)',
  enqReceivedOn: '{date}-ന് ലഭിച്ചു',
  enqSearchHint: 'പേര്, മൊബൈൽ, ഇമെയിൽ അല്ലെങ്കിൽ സന്ദേശം',
  enqShownCount: { one: '{count} അന്വേഷണം', other: '{count} അന്വേഷണങ്ങൾ' },
  enqDueCount: { one: '{count} ഫോളോ-അപ്പ് ബാക്കി', other: '{count} ഫോളോ-അപ്പുകൾ ബാക്കി' },
  enqShowDue: 'ബാക്കിയുള്ള ഫോളോ-അപ്പുകൾ കാണിക്കുക',
  enqShowAll: 'എല്ലാം കാണിക്കുക',
  enqNoMatch: 'ഈ ഫിൽട്ടറുകൾക്ക് യോജിക്കുന്ന അന്വേഷണങ്ങളില്ല.',
  enqFollowUp: 'ഫോളോ-അപ്പ്',
  enqFollowTitle: 'ഫോളോ-അപ്പ് · {name}',
  enqFollowUpOn: 'അടുത്ത ഫോളോ-അപ്പ്',
  enqFollowUpShort: '{date}-ന് ഫോളോ-അപ്പ്',
  enqNoFollowUp: 'തീയതി നൽകിയിട്ടില്ല',
  enqClearFollowUp: 'തീയതി മാറ്റുക',
  enqNotesHistory: 'കുറിപ്പുകളും കോൾ ചരിത്രവും',
  enqNoNotes: 'ഇതുവരെ കുറിപ്പുകളില്ല.',
  enqAddNote: 'കുറിപ്പ് ചേർക്കുക',
  enqAddNoteHint: 'എന്ത് സംസാരിച്ചു, അതിഥി എന്ത് ചോദിച്ചു, നിങ്ങൾ എന്ത് ഉറപ്പ് നൽകി…',
  enqHasNotes: 'കുറിപ്പുകളുണ്ട്',
  enqFollowSaved: 'അന്വേഷണം അപ്‌ഡേറ്റ് ചെയ്തു.',

  admSortBy: 'ക്രമീകരിക്കുക',
  admSortNewest: 'പുതിയത് ആദ്യം',
  admSortOldest: 'പഴയത് ആദ്യം',
  admSortName: 'പേര് (A–Z)',
  admSortCapacity: 'ഏറ്റവും കൂടുതൽ ശേഷി',
  admSortRating: 'ഉയർന്ന റേറ്റിംഗ്',
  admSortMostBookings: 'ഏറ്റവും കൂടുതൽ ബുക്കിംഗുകൾ',
  admSortMostVenues: 'ഏറ്റവും കൂടുതൽ വേദികൾ',
  admSortTopSpend: 'ഏറ്റവും കൂടുതൽ ചെലവ്',
  admSortHighestPrice: 'ഏറ്റവും ഉയർന്ന വില',
  admSortEventDate: 'പരിപാടിയുടെ തീയതി',
  admSortEventSoonest: 'പരിപാടിയുടെ തീയതി (അടുത്തത്)',
  admSortEventLatest: 'പരിപാടിയുടെ തീയതി (പിന്നീടുള്ളത്)',
  admSortUnhandledFirst: 'കൈകാര്യം ചെയ്യാത്തത് ആദ്യം',
  admFilteredCount: '{total}-ൽ {shown} കാണിക്കുന്നു',
  admAnyVerification: 'ഏത് പരിശോധനയും',
  admAnyListing: 'ലിസ്റ്റ് ചെയ്തതും അല്ലാത്തതും',
  admAnyPayment: 'ഏത് പേയ്‌മെന്റും',
  admAnyRole: 'എല്ലാവരും',
  admAnyEntity: 'എല്ലാം',
  admAnyKind: 'സന്ദേശങ്ങളും അപ്പീലുകളും',
  admKind: 'തരം',
  admKindContact: 'ബന്ധപ്പെടൽ സന്ദേശങ്ങൾ',
  admKindAppeal: 'സസ്പെൻഷൻ അപ്പീലുകൾ',
  admOptPendingVerif: 'പരിശോധന കാത്തിരിക്കുന്നു',
  admOptPendingApproval: 'അംഗീകാരം കാത്തിരിക്കുന്നു',
  admOptUnpaid: 'പണം നൽകിയിട്ടില്ല',
  admOptPartial: 'ഭാഗികമായി നൽകി',
  admOptPaid: 'മുഴുവൻ നൽകി',
  admSearchMessages: 'പേര്, മൊബൈൽ, ഇമെയിൽ, വിഷയം അല്ലെങ്കിൽ സന്ദേശം',
  admSearchEnquiries: 'അതിഥി, മൊബൈൽ, വേദി അല്ലെങ്കിൽ മാനേജർ',
  admSearchAudit: 'ആൾ, പ്രവൃത്തി അല്ലെങ്കിൽ റെക്കോർഡ് നമ്പർ',
  admNoMessageMatch: 'ഈ ഫിൽട്ടറുകൾക്ക് യോജിക്കുന്ന സന്ദേശങ്ങളില്ല.',

  hallMapsUrl: 'Google Maps ലിങ്ക്',
  hallMapsUrlInvalid: 'ഒരു Google Maps ലിങ്ക് ഒട്ടിക്കുക (google.com/maps അല്ലെങ്കിൽ maps.app.goo.gl)',
  hallMapsUrlTest: 'ലിങ്ക് പരിശോധിക്കുക',
  hallMapsFilled: 'മാപ്പ് ലിങ്കിൽ നിന്ന് വിലാസം പൂരിപ്പിച്ചു. ദയവായി പരിശോധിക്കുക.',
  hallNonAcRooms: 'നോൺ-എസി മുറികൾ',
  hallNonAcRoomCapacity: 'നോൺ-എസി മുറികളിൽ താമസിക്കാവുന്നവർ',
  hallSecFood: 'ഭക്ഷണവും ഡൈനിംഗും',
  hallDiningCapacity: 'ഡൈനിംഗ് ഇരിപ്പിട ശേഷി',
  hallDiningAcCapacity: 'എസി ഡൈനിംഗ് ഇരിപ്പിടങ്ങൾ',
  hallDiningHint:
    'ഒരേസമയം എത്ര അതിഥികൾക്ക് ഭക്ഷണം കഴിക്കാം, അതിൽ എത്ര ഇരിപ്പിടങ്ങൾക്ക് എസി ഉണ്ട്. ഡൈനിംഗ് ഏരിയ ഇല്ലെങ്കിൽ 0 നൽകുക.',
  hallDiningAcTooMany: 'ഡൈനിംഗ് ഇരിപ്പിട ശേഷിയേക്കാൾ കൂടുതലാകരുത്',
  hallHourlyPriceWhileOff:
    'മണിക്കൂർ ബുക്കിംഗ് ഓഫാണ്, അതിനാൽ അതിഥികൾക്ക് മണിക്കൂറിന് ബുക്ക് ചെയ്യാനാവില്ല. അത് ഓണാക്കുക, അല്ലെങ്കിൽ മണിക്കൂർ നിരക്ക് 0 ആക്കുക.',
  hallPeakMultiplierEffect: '×{factor} എന്നാൽ വാരാന്ത്യ ബുക്കിംഗുകൾക്ക് പ്രവൃത്തിദിവസങ്ങളേക്കാൾ {percent}% കൂടുതൽ.',
  hallPeakMultiplierSame: '1 എന്നാൽ വാരാന്ത്യത്തിലും അതേ നിരക്ക്. വാരാന്ത്യത്തിൽ 20% കൂടുതൽ ഈടാക്കാൻ 1.2 നൽകുക.',

  upLicenceNumberLabel: 'ലൈസൻസ് / സർട്ടിഫിക്കറ്റ് നമ്പർ',
  upLicenceNumberHint: 'ഉദാ. TCR/2021/04567',
  upLicenceAuthorityLabel: 'നൽകിയ അധികാരി',
  upLicenceAuthorityHint: 'ഉദാ. തൃശ്ശൂർ മുനിസിപ്പൽ കോർപ്പറേഷൻ',
  upFileTypes: 'PDF, JPG അല്ലെങ്കിൽ PNG · 10 MB വരെ',

  vnAcRooms: 'എസി മുറികൾ',
  vnNonAcRooms: 'നോൺ-എസി മുറികൾ',
  vnNonAcRoomsVal: { one: '{count} മുറി', other: '{count} മുറികൾ' },
  vnNonAcRoomsSleep: '{rooms} · {people} പേർക്ക് താമസിക്കാം',
  vnDining: 'ഡൈനിംഗ് ഏരിയ',
  vnDiningVal: '{count} ഇരിപ്പിടങ്ങൾ',
  vnDiningAcVal: '{count} ഇരിപ്പിടങ്ങൾ ({ac} എസി)',

  hallFacilities: 'സൗകര്യങ്ങൾ',
  hallFacilityRetired: 'ഇത് ഇപ്പോൾ പട്ടികയിലില്ല. ഈ വേദിയിൽ നിന്ന് മാറ്റാൻ ടിക്ക് നീക്കുക.',
};
